import type { ModuleManifest, ModuleRoute } from './moduleManifest';

export class ModuleRegistry {
  private readonly manifests = new Map<string, ModuleManifest>();

  register(manifest: ModuleManifest): void {
    if (this.manifests.has(manifest.id)) {
      throw new Error(`Module already registered: ${manifest.id}`);
    }
    this.manifests.set(manifest.id, manifest);
  }

  registerMany(manifests: readonly ModuleManifest[]): void {
    manifests.forEach((manifest) => this.register(manifest));
  }

  get(moduleId: string): ModuleManifest | undefined {
    return this.manifests.get(moduleId);
  }

  getAll(): ModuleManifest[] {
    return Array.from(this.manifests.values());
  }

  getEnabled(): ModuleManifest[] {
    return this.getAll().filter((manifest) => manifest.enabled !== false);
  }

  findRouteByLegacyView(view: string): { manifest: ModuleManifest; route: ModuleRoute } | undefined {
    for (const manifest of this.getEnabled()) {
      const route = manifest.routes.find((candidate) =>
        candidate.legacyViews?.includes(view),
      );
      if (route) return { manifest, route };
    }
    return undefined;
  }

  findRouteByPath(pathname: string): { manifest: ModuleManifest; route: ModuleRoute } | undefined {
    const normalizedPath = pathname.replace(/\/+$/, '') || '/';
    for (const manifest of this.getEnabled()) {
      const route = manifest.routes.find((candidate) => {
        const normalizedRoute = candidate.path.replace(/\/+$/, '') || '/';
        return normalizedPath === normalizedRoute || normalizedPath.startsWith(`${normalizedRoute}/`);
      });
      if (route) return { manifest, route };
    }
    return undefined;
  }
}
